// Współrzędne geograficzne (lat, lng) głównych lotnisk obsługiwanych przez portal.
// Używane do liczenia odległości po wielkim kole (haversine) i estymacji czasu lotu.

export const AIRPORT_COORDS: Record<string, [number, number]> = {
  // Polska
  WAW: [52.1657, 20.9671], WMI: [52.4511, 20.6518], KRK: [50.0777, 19.7848],
  GDN: [54.3776, 18.4662], WRO: [51.1027, 16.8858], POZ: [52.4210, 16.8263],
  KTW: [50.4743, 19.0800], SZZ: [53.5847, 14.9022], RZE: [50.1100, 22.0190],
  LCJ: [51.7219, 19.3981], BZG: [53.0968, 17.9777], LUZ: [51.2403, 22.7136],
  SZY: [53.4819, 20.9377], RDO: [51.3893, 21.2133], IEG: [52.1385, 15.7986],

  // Wielka Brytania / Irlandia
  LHR: [51.4700, -0.4543], LGW: [51.1537, -0.1821], STN: [51.8860, 0.2389],
  LTN: [51.8747, -0.3683], MAN: [53.3537, -2.2750], EDI: [55.9500, -3.3725],
  DUB: [53.4213, -6.2700],

  // Francja
  CDG: [49.0097, 2.5479], ORY: [48.7233, 2.3794], NCE: [43.6584, 7.2159],

  // Hiszpania / Portugalia
  BCN: [41.2974, 2.0833], MAD: [40.4983, -3.5676], AGP: [36.6749, -4.4991],
  ALC: [38.2822, -0.5582], PMI: [39.5517, 2.7388], TFS: [28.0445, -16.5725],
  LPA: [27.9319, -15.3866], FAO: [37.0144, -7.9659], LIS: [38.7742, -9.1342],
  OPO: [41.2481, -8.6814],

  // Włochy
  FCO: [41.8003, 12.2389], MXP: [45.6306, 8.7281], BGY: [45.6739, 9.7042],
  NAP: [40.8860, 14.2908], VCE: [45.5053, 12.3519],

  // BeNeLux / Niemcy / Austria / CH
  AMS: [52.3105, 4.7683], BRU: [50.9014, 4.4844], FRA: [50.0379, 8.5622],
  MUC: [48.3538, 11.7861], BER: [52.3667, 13.5033], HAM: [53.6304, 9.9882],
  DUS: [51.2895, 6.7668], CGN: [50.8659, 7.1427], VIE: [48.1102, 16.5697],
  ZRH: [47.4647, 8.5492],

  // Skandynawia
  CPH: [55.6180, 12.6508], ARN: [59.6519, 17.9186], OSL: [60.1939, 11.1004],
  HEL: [60.3172, 24.9633], KEF: [63.9850, -22.6056],

  // Europa Środkowa / Wschodnia / Bałkany
  PRG: [50.1008, 14.2632], BUD: [47.4369, 19.2556], OTP: [44.5711, 26.0858],
  SOF: [42.6967, 23.4114], VAR: [43.2321, 27.8251], BOJ: [42.5696, 27.5152],
  SPU: [43.5389, 16.2980], DBV: [42.5614, 18.2683], TIA: [41.4147, 19.7206],
  TIV: [42.4047, 18.7233], ZAG: [45.7429, 16.0688],

  // Grecja / Cypr / Malta
  ATH: [37.9364, 23.9445], HER: [35.3397, 25.1803], RHO: [36.4054, 28.0862],
  JTR: [36.3992, 25.4793], SKG: [40.5197, 22.9709], CFU: [39.6019, 19.9117],
  KGS: [36.7933, 27.0917], LCA: [34.8751, 33.6249], PFO: [34.7180, 32.4857],
  MLA: [35.8575, 14.4775],

  // Turcja
  IST: [41.2753, 28.7519], SAW: [40.8986, 29.3092], AYT: [36.8987, 30.8005],
  BJV: [37.2506, 27.6643], ESB: [40.1281, 32.9951],

  // Bliski Wschód / Azja / egzotyka
  DXB: [25.2532, 55.3657], AUH: [24.4330, 54.6511], DOH: [25.2731, 51.6086],
  TLV: [32.0114, 34.8867], BKK: [13.6900, 100.7501], DMK: [13.9126, 100.6067],
  HKT: [8.1132, 98.3169], DPS: [-8.7482, 115.1672], CGK: [-6.1256, 106.6559],
  MLE: [4.1918, 73.5291], CMB: [7.1808, 79.8842], DEL: [28.5562, 77.1000],
  BOM: [19.0896, 72.8656], NRT: [35.7720, 140.3929], HND: [35.5494, 139.7798],
  ICN: [37.4602, 126.4407], SIN: [1.3644, 103.9915],

  // Afryka
  HRG: [27.1783, 33.7994], SSH: [27.9773, 34.3950], RMF: [25.5571, 34.7833],
  CAI: [30.1219, 31.4056], RAK: [31.6069, -8.0363], CMN: [33.3675, -7.5898],
  AGA: [30.3811, -9.5464], TUN: [36.8510, 10.2272], DJE: [33.8750, 10.7755],

  // Ameryki
  JFK: [40.6413, -73.7781], EWR: [40.6895, -74.1745], LAX: [33.9416, -118.4085],
  MIA: [25.7959, -80.2870], ORD: [41.9742, -87.9073], YYZ: [43.6777, -79.6248],
  CUN: [21.0365, -86.8771], MEX: [19.4361, -99.0719], PUJ: [18.5673, -68.3634],
  HAV: [22.9892, -82.4091], GIG: [-22.8100, -43.2506], EZE: [-34.8222, -58.5358],
};

// Haversine — odległość po wielkim kole (km).
export function haversineKm(a: [number, number], b: [number, number]): number {
  const R = 6371;
  const toRad = (x: number) => (x * Math.PI) / 180;
  const dLat = toRad(b[0] - a[0]);
  const dLng = toRad(b[1] - a[1]);
  const lat1 = toRad(a[0]);
  const lat2 = toRad(b[0]);
  const h =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLng / 2) ** 2;
  return 2 * R * Math.asin(Math.sqrt(h));
}

// Szacowany czas lotu: prędkość rejsowa ~820 km/h + 25 min na taxi/wznoszenie/zniżanie.
export function estimateFlightDuration(km: number): { hours: number; minutes: number; label: string } {
  const cruiseMin = (km / 820) * 60;
  const totalMin = Math.round(cruiseMin + 25);
  const hours = Math.floor(totalMin / 60);
  const minutes = totalMin % 60;
  const label = hours === 0
    ? `${minutes} min`
    : minutes === 0
      ? `${hours} godz.`
      : `${hours} godz. ${minutes} min`;
  return { hours, minutes, label };
}

export function distanceBetween(fromIata: string, toIata: string): number | null {
  const a = AIRPORT_COORDS[fromIata.toUpperCase()];
  const b = AIRPORT_COORDS[toIata.toUpperCase()];
  if (!a || !b) return null;
  return Math.round(haversineKm(a, b));
}
